module.exports = __webpack_public_path__ + "fonts/Barlow-Bold.77c5a751.eot";